import { Card, BlockStack, Text } from '@shopify/polaris';

export interface WrapperTooltipProps {
  children: React.ReactNode;
  title?: string;
}
export const WrapperTooltip: React.FC<WrapperTooltipProps> = ({ children, title }) => {
  return (
    <div className="min-w-[175px] w-fit">
      <Card padding={'200'}>
        <BlockStack gap={'100'}>
          <Text as="p" variant="bodySm" fontWeight="semibold">
            {title}
          </Text>
          <BlockStack gap={'200'}>{children}</BlockStack>
        </BlockStack>
      </Card>
    </div>
  );
};
